import React from "react";
import { DialogContextType } from "./types";

export function createDialogProvider<T>(
  DialogContext: React.Context<DialogContextType<T>>,
  DialogComponent: React.ComponentType<T>,
  id: string
) {
  const DialogProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [dialogProps, setDialogProps] = React.useState<T | undefined>(
      undefined
    );

    const openDialog = React.useCallback((props: T) => {
      // Using setTimeout to ensure any UI elements (like context menus) are closed
      // before opening the dialog. This avoids UI overlap and ensures correct focus/scroll behavior.
      setTimeout(() => {
        setDialogProps(props);
      }, 0);
    }, []);

    const closeDialog = React.useCallback(() => {
      setDialogProps(undefined);
    }, []);

    return (
      <DialogContext.Provider value={{ openDialog, closeDialog, id }}>
        {children}
        {dialogProps && <DialogComponent {...dialogProps} />}
      </DialogContext.Provider>
    );
  };

  return { DialogProvider };
}
